<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-switch
        v-model="isValidValue"
        :label="title"
        class="v-input--reverse"
      />
    </v-flex>
    <v-flex v-if="isValidValue" xs10 offset-xs1>
      <v-layout row>
        <v-flex xs1>
          <v-text-field
            @keydown.arrow-down.prevent
            @keydown.arrow-up.prevent
            @wheel.prevent
            v-model.number="thresholdValue"
            :rules="rules"
            :suffix="suffixText"
            type="number"
            style="padding-top: 0px;"
          />
        </v-flex>
        <v-flex xs1 ml-5>
          <v-select
            :items="conditions"
            v-model="thresholdConditionValue"
            :item-text="'name'"
            :item-value="'value'"
            dense
            style="padding-top: 0px;"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'CampaignModalPageMansionCondition',
  props: {
    threshold: {
      type: Number,
      default: 1,
    },
    thresholdCondition: {
      type: String,
      default: 'greater',
    },
    suffixText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      thresholdValue: this.threshold,
      thresholdConditionValue: this.thresholdCondition,
      isValidValue: this.isValid,
    }
  },
  computed: {
    conditions() {
      return [
        { name: '以上', value: 'greater' },
        { name: '以下', value: 'less' },
      ]
    },
    rules() {
      return [
        p => (p !== undefined && p !== '') || '入力してください',
        p => Number.isInteger(Number(p)) || '整数で入力して下さい',
        p => p > 0 || '1以上の数字を入力してください',
      ]
    },
  },
  watch: {
    thresholdValue: {
      handler(value) {
        this.$emit('onChangeThreshold', value)
      },
    },
    thresholdConditionValue: {
      handler(value) {
        this.$emit('onChangeThresholdCondition', value)
      },
    },
    isValidValue: {
      handler(value) {
        this.$emit('onChangeIsValid', value)
      },
    },
  },
}
</script>

<style scoped lang="scss">
.v-input--reverse {
  ::v-deep .v-input__slot {
    flex-direction: row-reverse;
    .v-input--selection-controls__input {
      margin-left: 8px;
    }
  }
}
</style>
